import { z } from 'zod';
import { ExtensibleFieldsSchema } from '../types/extensible';
import { SchoolDivision, StaffRole, StaffStatus } from '../types/enums';

export const OrganizationProfileSchema = z.object({
  name: z.string(),
  shortName: z.string(),
  primaryColor: z.string(),
  secondaryColor: z.string(),
  address: z.object({
    street: z.string(),
    city: z.string(),
    state: z.string(),
    zip: z.string(),
  }).passthrough(),
  phone: z.string(),
  phoneExt: z.string(),
  emailAdmissions: z.string(),
  emailSupport: z.string(),
  website: z.string(),
  missionStatement: z.string(),
  timezone: z.string(),
  logo: z.string().nullable(),
  ext: ExtensibleFieldsSchema.optional(),
}).passthrough();
export type OrganizationProfile = z.infer<typeof OrganizationProfileSchema>;

export const DivisionSchema = z.object({
  id: z.string(),
  type: SchoolDivision,
  displayName: z.string(),
  enabled: z.boolean(),
  secretaryEmail: z.string().optional(),
  principalId: z.string().optional(),
  primaryStaffId: z.string().optional(),
  ext: ExtensibleFieldsSchema.optional(),
}).passthrough();
export type Division = z.infer<typeof DivisionSchema>;

export const StaffUserSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  role: StaffRole,
  status: StaffStatus,
  lastActive: z.string().optional(),
}).passthrough();
export type StaffUser = z.infer<typeof StaffUserSchema>;

export const TuitionRateSchema = z.object({
  id: z.string(),
  gradeLabel: z.string(),
  gender: z.enum(['all', 'boys', 'girls']),
  amount: z.number(),
}).passthrough();
export type TuitionRate = z.infer<typeof TuitionRateSchema>;

export const FeeSchema = z.object({
  id: z.string(),
  name: z.string(),
  amount: z.number(),
}).passthrough();
export type Fee = z.infer<typeof FeeSchema>;
